import { useCallback } from 'react';
import type { BuiltinPrintTemplate } from 'shared-types';
import { t } from '../../potree/translation/markers';
import { useTranslator } from '../../translation/src';

/** The built-in templates' names and descriptions, marked for translation (the data lives in shared-types). */
const BUILTIN_TEXT: Record<string, { name: string; description: string }> = {
  'a3-plan': { name: t('A3 floor plan'), description: t('A3 landscape plan sheet at 1:100 with ISO title block, revisions, north arrow and scale bar. One page per floor.') },
  'a1-plan': { name: t('A1 floor plan'), description: t('A1 landscape plan sheet at 1:50 with ISO title block, revisions, north arrow and scale bar. One page per floor.') },
  'a4-report': { name: t('A4 report'), description: t('A4 portrait page with logo header, plan, notes and footer. One page per floor.') },
  'a3-density': { name: t('A3 density map'), description: t('A3 landscape X-ray density map at 300 dpi with title strip, north arrow and scale bar.') },
  'a3-heatmap': { name: t('A3 heatmap'), description: t('A3 landscape heatmap with legend, title strip, north arrow and scale bar.') },
};

/** Translated name + description of a built-in template. */
export function useBuiltinTemplateText(): (template: Pick<BuiltinPrintTemplate, 'id' | 'name' | 'description'>) => { name: string; description: string } {
  const translate = useTranslator();
  return useCallback(
    (template) => {
      const text = BUILTIN_TEXT[template.id] ?? template;
      return { name: translate(text.name), description: translate(text.description) };
    },
    [translate],
  );
}
